/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ReferrerAlertTypeResource = {
    BankInformation: 'BANK_INFORMATION',
    ComplianceDocuments: 'COMPLIANCE_DOCUMENTS'
} as const;
export type ReferrerAlertTypeResource = typeof ReferrerAlertTypeResource[keyof typeof ReferrerAlertTypeResource];


export function instanceOfReferrerAlertTypeResource(value: any): boolean {
    for (const key in ReferrerAlertTypeResource) {
        if (Object.prototype.hasOwnProperty.call(ReferrerAlertTypeResource, key)) {
            // @ts-ignore
            if (ReferrerAlertTypeResource[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ReferrerAlertTypeResourceFromJSON(json: any): ReferrerAlertTypeResource {
    return ReferrerAlertTypeResourceFromJSONTyped(json, false);
}

export function ReferrerAlertTypeResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferrerAlertTypeResource {
    return json as ReferrerAlertTypeResource;
}

export function ReferrerAlertTypeResourceToJSON(value?: ReferrerAlertTypeResource | null): any {
    return value as any;
}

